import { render, staticRenderFns } from "./rename-year-dialog.vue?vue&type=template&id=386833cc"
import script from "./rename-year-dialog.vue?vue&type=script&lang=js"
export * from "./rename-year-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports